import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    // Check if it's a MetaMask error - if so, ignore it
    const errorMessage = String(error?.message || '');
    const errorStack = String(error?.stack || '');

    if (
      errorMessage.includes('MetaMask') ||
      errorMessage.includes('ethereum') ||
      errorMessage.includes('Failed to connect') ||
      errorStack.includes('chrome-extension://') ||
      errorStack.includes('MetaMask')
    ) {
      console.warn('[Suppressed] MetaMask extension error:', errorMessage);
      return { hasError: false }; // Don't show error UI
    }

    // For other errors, show error UI
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Don't log MetaMask errors
    const errorMessage = String(error?.message || '');
    const errorStack = String(error?.stack || '');

    if (
      errorMessage.includes('MetaMask') ||
      errorMessage.includes('ethereum') ||
      errorMessage.includes('Failed to connect') ||
      errorStack.includes('chrome-extension://') ||
      errorStack.includes('MetaMask')
    ) {
      return;
    }

    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return <div>Something went wrong. Please refresh the page.</div>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
